@for (avatar of avatars | pureslice : 0 : maxAvatars; track avatar; let i = $index) {
  <ca-avatar
    [class]="size"
    [fullName]="avatar.fullName"
    [image]="avatar.image ?? (avatar.imageId | filedownloadurl | async)"
    [style.zIndex]="20 - i"
  ></ca-avatar>
}
